var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-tabs',{staticClass:"honjo-tabs",model:{value:(_vm.activeValue),callback:function ($$v) {_vm.activeValue=$$v},expression:"activeValue"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }